const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-job-card'] = {
        c: () => require('partner/modules/ecomm-job-card/ecomm-job-card.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-job-card',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-job-card'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-job-card|ecomm-job-card'] = {
                c: () => require('partner/modules/ecomm-job-card/ecomm-job-card.view.tsx'),
                cn: '__local__-__local__-ecomm-job-card'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };